export default __webpack_public_path__ + "static/media/10_Reyes Mañeru.77d78906.webp";